import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type NavigationMenu from '../../types/navigationMenu';

export type IState = {
  data: NavigationMenu;
};

const initialState: IState = {
  data: [],
};

const navigationMenu = createSlice({
  name: 'navigationMenu',
  initialState,
  reducers: {
    setNavigationMenu: (state, { payload }: PayloadAction<NavigationMenu>) => {
      state.data = payload;
    },
  },
});

const { actions, reducer } = navigationMenu;

export const { setNavigationMenu } = actions;

export default reducer;
